import { render, staticRenderFns } from "./RealEstimado.vue?vue&type=template&id=34709940&scoped=true"
import script from "./RealEstimado.vue?vue&type=script&lang=js"
export * from "./RealEstimado.vue?vue&type=script&lang=js"
import style0 from "./RealEstimado.vue?vue&type=style&index=0&id=34709940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34709940",
  null
  
)

export default component.exports